import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionUploadPdfMaster = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const pdfFile = useRef(null);

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        sectionSyllabusStructureMasterId: '',
        instituteSubjectMasterId: '',
        tagMasterId: '',
        filePath: '',
        fileName: '',
        title: '',
        description: ''
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [PdfBookList, setPdfBookList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState(false)
    const [tag, setTag] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusStructureNameSort, setSyllabusStructureNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [pdfNameSort, setPdfNameSort] = useState(null);
    const [tagNameSort, setTagNameSort] = useState(null);
    const [titleSort, setTitleSort] = useState(null);
    const [descriptionSort, setDescriptionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "tagMasterDetails.tagName", "fileName", "title", "description"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
        getTags();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getPdfList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (PdfBookData.sectionSyllabusStructureMasterId !== '') {
                setPdfBookList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(PdfBookList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(PdfBookList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > PdfBookList.length) {
            endIndex = PdfBookList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(PdfBookList.slice(startIndex, endIndex));
    }, [PdfBookList, currPage, itemsPerPage]);

    const getTags = () => {
        const apiUrl = `/get-section-tag-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getApiUrl = () => {
        let apiUrl = `/get-section-pdf-book-list?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;
        if (PdfBookData.sectionSyllabusStructureMasterId !== '') {
            apiUrl += `sectionSyllabusStructureMasterId=${PdfBookData.sectionSyllabusStructureMasterId}&`;
        }
        if (PdfBookData.instituteSubjectMasterId !== '') {
            apiUrl += `instituteSubjectMasterId=${PdfBookData.instituteSubjectMasterId}&`;
        }
        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getPdfList();
    }, [PdfBookData.sectionSyllabusStructureMasterId, PdfBookData.instituteSubjectMasterId, PdfBookData.tagMasterId]);

    const getPdfList = async () => {
        if (PdfBookData.sectionSyllabusStructureMasterId !== '') {
            try {
                const response = await authorizedAxiosSection.get(getApiUrl());
                setPdfBookList(response.data.result);
            } catch (error) {
                setPdfBookList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-section-syllabus-structure?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: ''
            }
        })
        const apiUrl = `/get-section-syllabus-structure-Wise-section-subjects?id=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(PdfBookData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [PdfBookData])

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const fileName = file.name.split(".")[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const maxFileSize = 50 * 1024 * 1024; // 50MB

        if (fileExtension !== "pdf") {
            e.target.value = ''; // Reset the file input
            return Swal.fire({ text: "Only PDF files are supported" });
        }

        if (file.size > maxFileSize) {
            e.target.value = ''; // Reset the file input
            return Swal.fire({ text: "Max size 50MB file supported" });
        }

        setLoading(true);
        const body = new FormData();
        body.append("file", file);
        body.append("flag", "2"); // 2 -> content path in S3 bucket

        try {
            const apiUrl = "uploadfile-v2";
            const response = await authorizedAxiosCommonFileUpload.post(apiUrl, body);
            const { result } = response.data;

            setPdfBookData(prevData => ({
                ...prevData,
                [e.target.name]: result,
                fileName: fileName
            }));
        } catch (err) {
            const errorMsg = err?.response?.data?.error || "Something went wrong!";
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false);
        }
    };

    const addPdfBook = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section-pdf-book`;
                const response = await authorizedAxiosSection.post(apiUrl, PdfBookData);
                setPdfBookData((prevData) => {
                    return {
                        ...prevData,
                        fileName: '',
                        filePath: '',
                        title: '',
                        description: ''
                    }
                })

                pdfFile.current.value = '';
                setSaveId(response.data.result.id);
                setSyllabusStructureNameSort(null);
                setSubjectSort(null);
                setPdfNameSort(null);
                setTagNameSort(null);
                setTitleSort(null);
                setDescriptionSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-pdf-book?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, PdfBookList.length);
                await getPdfList();
                setCurrPage(page);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        if (syllabusStructureNameSort == true || syllabusStructureNameSort == false) {
            setSubjectSort(null);
            setPdfNameSort(null);
            setTagNameSort(null);
            setTitleSort(null);
            setDescriptionSort(null);
        }
    }, [syllabusStructureNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setSyllabusStructureNameSort(null);
            setPdfNameSort(null);
            setTagNameSort(null);
            setTitleSort(null);
            setDescriptionSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (pdfNameSort == true || pdfNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setTagNameSort(null);
            setTitleSort(null);
            setDescriptionSort(null);
        }
    }, [pdfNameSort])

    useEffect(() => {
        if (tagNameSort == true || tagNameSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setPdfNameSort(null);
            setTitleSort(null);
            setDescriptionSort(null);
        }
    }, [tagNameSort])

    useEffect(() => {
        if (titleSort == true || titleSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setPdfNameSort(null);
            setTagNameSort(null);
            setDescriptionSort(null);
        }
    }, [titleSort])

    useEffect(() => {
        if (descriptionSort == true || descriptionSort == false) {
            setSyllabusStructureNameSort(null);
            setSubjectSort(null);
            setPdfNameSort(null);
            setTagNameSort(null);
            setTitleSort(null);
        }
    }, [descriptionSort])

    const handleInputReset = () => {
        setPdfBookData(initialFormState);
        setEditId('');
        setPdfBookList([]);
        pdfFile.current.value = '';
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Section Upload Pdf Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-file-pdf"></i> Section Upload Pdf Master </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionSyllabusStructureMasterId' onChange={handleSyllabusChange} value={PdfBookData.sectionSyllabusStructureMasterId}>
                                                        <option selected value={''} disabled>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.sectionSyllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.sectionSyllabusStructureMasterId && <p style={{ color: 'red' }}>{error.sectionSyllabusStructureMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleInputChange} value={PdfBookData.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteSubjectMasterId && <p style={{ color: 'red' }}>{error.instituteSubjectMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Tag:</label>
                                                    <select class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Pdf Book : </label>
                                                    <label style={{ color: "red" }} > max 50 Mb pdf file supported</label>
                                                    <input type="file" className="form-control" name="filePath" onChange={handleUploadLogo} ref={pdfFile} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>
                                            </div>
                                            <CModal
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book pdf-modal">
                                                    <iframe height={450} width={"100%"} className="page" src={showPdfLink}></iframe>
                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addPdfBook}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Name
                                                                            <SortIcon sortState={syllabusStructureNameSort} setSortState={setSyllabusStructureNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"sectionSyllabusStructureMasterDetails.sectionSyllabusStructureName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagNameSort} setSortState={setTagNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Pdf Name
                                                                            <SortIcon sortState={pdfNameSort} setSortState={setPdfNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"fileName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Title
                                                                            <SortIcon sortState={titleSort} setSortState={setTitleSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Description
                                                                            <SortIcon sortState={descriptionSort} setSortState={setDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Pdf</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.sectionSyllabusStructureMasterDetails?.sectionSyllabusStructureName}</td>
                                                                                        <td>{lesson.instituteSubjectMasterDetails.subjectName}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson.fileName}</td>
                                                                                        <td>{lesson?.title}</td>
                                                                                        <td>{lesson?.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye"></i>PDF</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Pdf Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={PdfBookList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionUploadPdfMaster;